








import Vue from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ReportNumber",
  props: {
    reportNumberBody: {
      type: Number,
      default: 0
    }
  }
});
